module.exports = __webpack_public_path__ + "img/numbered_list-disabled.b21eead5.svg";